<template>
    <div id="app">

        <header-wrapper />


        <div class="page-layout">

            <div class="page-container uk-background-muted">

                <div class="uk-padding uk-padding-remove-left uk-padding-remove-right uk-position-relative" uk-height-viewport="offset-top: true">
                    <div class="uk-container">

                        <router-view />

                    </div>
                </div>
            </div>

        </div>


        <nav-mobile />

    </div>
</template>

<script>

    export default {
        name: 'app',
    }

</script>
